var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "confirmation-guide-wrap" },
    [
      _c("VHeader"),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "tips" }, [
          _c("i", { staticClass: "el-icon-warning" }),
          _vm._v(
            "\n      " + _vm._s(_vm.$t("confirmationGuideTips")) + "\n    "
          ),
        ]),
        _c(
          "div",
          { staticClass: "list" },
          [
            _vm._l(_vm.hasPdfList, function (bank, index) {
              return [
                _c(
                  "a",
                  {
                    key: index,
                    style: _vm.pdfNameMap[bank.slice(0, 6)]
                      ? {}
                      : { "pointer-events": "none", color: "#b7b4b4" },
                    attrs: {
                      href: "/static/confirmation/" + bank + ".pdf",
                      target: "_blank",
                    },
                  },
                  [
                    _c("span", { staticClass: "index" }, [
                      _vm._v(_vm._s(index + 1) + ". "),
                    ]),
                    _vm.pdfNameMap[bank.slice(0, 6)]
                      ? _c("i", { staticClass: "el-icon-download" })
                      : _vm._e(),
                    _vm._v(
                      "\n          " +
                        _vm._s(bank) +
                        " " +
                        _vm._s(
                          `${_vm.pdfNameMap[bank.slice(0, 6)] ? ".pdf" : ""}`
                        ) +
                        "\n        "
                    ),
                  ]
                ),
              ]
            }),
          ],
          2
        ),
      ]),
      _c("VBottom"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }